var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messageBar"},_vm._l((_vm.messages),function(message){return _c('div',{key:message.messageID,staticClass:"alert",class:_vm.alertClass(message.status)},[_vm._v(" "+_vm._s(message.status > 200 ? message.status : "")+" "+_vm._s(message.message)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }